module.exports = __webpack_public_path__ + "img/part3@2x.c3519ff2.png";